import React from "react";
import { useFormContext } from "../../context/FormContext";
import styles from "./SuccessScreen.module.css";

const SuccessScreen = () => {
  const { merchant, merchant_name, ticketId } = useFormContext();
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <img
          src="https://res.cloudinary.com/crown-interactive/image/upload/v1652192061/success_yhtjst.svg"
          alt=""
        />
        <p className={styles.success}>Success</p>
        <p>
          Please check your email for further information. If you have
          <br />
          not received this in the next few minutes, do have a look in
          <br />
          your junk email
        </p>
        <br />
        <p>Here is the ticket number for your reference</p>
        <p className={styles.ticket}>
          {" "}
          <strong>{ticketId}</strong>
        </p>
        <a href={window.location.href} className={styles.submit}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            fill="#0082d3"
            viewBox="0 0 512 512"
          >
            <path d="M496 48V192c0 17.69-14.31 32-32 32H320c-17.69 0-32-14.31-32-32s14.31-32 32-32h63.39c-29.97-39.7-77.25-63.78-127.6-63.78C167.7 96.22 96 167.9 96 256s71.69 159.8 159.8 159.8c34.88 0 68.03-11.03 95.88-31.94c14.22-10.53 34.22-7.75 44.81 6.375c10.59 14.16 7.75 34.22-6.375 44.81c-39.03 29.28-85.36 44.86-134.2 44.86C132.5 479.9 32 379.4 32 256s100.5-223.9 223.9-223.9c69.15 0 134 32.47 176.1 86.12V48c0-17.69 14.31-32 32-32S496 30.31 496 48z" />
          </svg>
          Submit another response
        </a>
        <div className={styles.footer}>
          <p>
            This form was created by <strong>{merchant?.companyName || merchant_name}</strong>
            <br />
            Powered by <a href="#!">CICOD Workflow Manager</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessScreen;
